import { BenefitTypes, ReferentPriceTypes } from '@strata/constants';
import { validationStrings } from '@strata/strata-ui-strings';
import dayjs from 'dayjs';
import * as Yup from 'yup';

const PlacesOfService = {
    FACILITY: 'FACILITY',
    INFU_INFU: 'INFU_INFU',
    INFU_SPEC: 'INFU_SPEC',
    HOME: 'HOME',
    PHYS_SPEC: 'PHYS_SPEC',
    PHYS_PHYS: 'PHYS_PHYS',
};

const booleanValidationString = 'Must be a 1 or a 0.';
const numberValidationString = 'Must be a valid number.';
const dateValidationStirng = 'Must be a valid ISO datetime value.';
const minNumberValidationString = (max) => `Must be more than ${max}.`;
const maxNumberValidationString = (max) => `Must be less than ${max}.`;
const oneOfValidationString = (list) => `Must be one of the following values: ${list.join(', ')}`;

export const SEGMENT_BELONGS_TO_PAYER_MESSAGE = 'Segment does not belong to the selected payer.';

export const buildRateRuleValidationSchema = (validSegmentIds) => ({
    product_service_id: Yup.string().required(validationStrings.requiredField.errorMessage),
    benefit: Yup.string()
        .oneOf(Object.values(BenefitTypes), oneOfValidationString(Object.values(BenefitTypes)))
        .required(validationStrings.requiredField.errorMessage),
    place_of_service: Yup.string()
        .oneOf(
            Object.values(PlacesOfService),
            oneOfValidationString(Object.values(PlacesOfService)),
        )
        .nullable(),
    is_generic: Yup.boolean()
        .typeError(booleanValidationString)
        .required(validationStrings.requiredField.errorMessage),
    line_of_business: Yup.string().nullable(),
    segment_id: Yup.string()
        .required(validationStrings.requiredField.errorMessage)
        .oneOf(validSegmentIds, SEGMENT_BELONGS_TO_PAYER_MESSAGE),
    location: Yup.string().nullable(),
    referent_price_type: Yup.string()
        .oneOf(
            Object.values(ReferentPriceTypes),
            oneOfValidationString(Object.values(ReferentPriceTypes)),
        )
        .required(validationStrings.requiredField.errorMessage),
    default_rate: Yup.number(numberValidationString)
        .moreThan(-1, minNumberValidationString(-1))
        .lessThan(2, maxNumberValidationString(2)),
    baseline_rate: Yup.number(numberValidationString)
        .moreThan(-1, minNumberValidationString(-1))
        .lessThan(2, maxNumberValidationString(2)),
    pbm_rate: Yup.number(numberValidationString)
        .nullable()
        .moreThan(-1, minNumberValidationString(-1))
        .lessThan(2, maxNumberValidationString(2)),
    market_override_rate: Yup.number(numberValidationString)
        .nullable()
        .moreThan(-1, minNumberValidationString(-1))
        .lessThan(2, maxNumberValidationString(2)),
    market_override_reason: Yup.string().when('market_override_rate', {
        is: (value) => value != null && value !== '',
        then: (schema) => schema.required(validationStrings.requiredField.errorMessage),
        otherwise: (schema) => schema.nullable(),
    }),
    effective_start_date: Yup.date()
        .typeError(dateValidationStirng)
        .min(dayjs().toDate(), 'Effective start date must be after current datetime.'),
    effective_end_date: Yup.date()
        .nullable()
        .typeError(dateValidationStirng)
        .min(dayjs().toDate(), 'Effective end date must be after current datetime.')
        .when('effective_start_date', ([startDate], schema) =>
            startDate
                ? schema.min(
                      dayjs(startDate).toDate(),
                      'Effective end date must be after effective start date.',
                  )
                : schema,
        ),
    is_frozen: Yup.boolean()
        .typeError(booleanValidationString)
        .required(validationStrings.requiredField.errorMessage),
    price_source: Yup.string().required(validationStrings.requiredField.errorMessage),
});
